// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".route-item{display:flex;align-items:center;width:260px;height:100%;padding-left:18px;box-sizing:border-box}.route-item .svg-icon{width:24px!important;height:24px!important;margin-right:10px}", ""]);
// Exports
module.exports = exports;
